module.exports = __webpack_public_path__ + "img/card6.08f24e58.png";